// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__mAW1l","label":"Labeled_label__33IoD","divider":"Labeled_divider__1ZJTV"};